import { useApolloClient } from '@apollo/client'
import React from 'react'
import { useMarkAllStudentCommentsAsReadMutation } from '../../../../generated/graphql'
import { updateAllPlanCommentsCache } from '../../../../lib/cacheUtils'
import useModal from '../../../../lib/hooks/useModal'
import useNotification from '../../../../lib/hooks/useNotification'
import MarkCommentsAsReadModal from './MarkCommentsAsReadModal'

type MarkCommentsAsReadModalWrapperProps = {
  /** Indicates if the modal is open */
  isOpen: boolean
  advisorExternalId: string
  includeAllStudents: boolean
  selectedStudentsCount: number
  allStudentsCount: number
  selectedStudentIds: Array<string>
  unselectedStudentIds: Array<string>
  onMarkCommentsCompleted(): void
}

const MarkCommentsAsReadModalWrapper = ({
  isOpen,
  advisorExternalId,
  includeAllStudents,
  selectedStudentsCount,
  allStudentsCount,
  selectedStudentIds,
  unselectedStudentIds,
  onMarkCommentsCompleted
}: MarkCommentsAsReadModalWrapperProps) => {
  const { hideModal } = useModal()
  const { showErrorNotif } = useNotification()
  const apolloClient = useApolloClient()

  const [markCommentsAsRead] = useMarkAllStudentCommentsAsReadMutation({
    onError: () => {
      showErrorNotif('Comments could not be marked as read.', markCommentsAsRead)
    }
  })

  const onCancel = () => {
    hideModal()
  }

  const onSave = (selectedOption: string) => {
    markCommentsAsRead({
      variables: {
        advisorExternalId,
        includeIds: selectedOption === 'all' ? [] : selectedStudentIds,
        excludeIds: selectedOption === 'all' ? [] : unselectedStudentIds,
        includeAllStudents
      },
      onCompleted: (data) => {
        const planIds = data?.markAllStudentCommentsAsRead?.ids || []
        updateAllPlanCommentsCache(apolloClient.cache, planIds)
        onMarkCommentsCompleted()
        hideModal()
      }
    })
  }

  return (
    <MarkCommentsAsReadModal
      isOpen={isOpen}
      onCancel={onCancel}
      onSave={onSave}
      selectedStudentsCount={selectedStudentsCount}
      allStudentsCount={allStudentsCount}
    />
  )
}

export default MarkCommentsAsReadModalWrapper
